import { useMemo } from 'react';

import { Popover as MuiPopover, styled } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// eslint-disable-next-line @nx/enforce-module-boundaries -- Module Federation singleton 키를 유지하려면 패키지 경로 import가 필요합니다.
import { usePopupContext } from '@kc-console/common-ui/singleton';

import { PopoverOrigin } from '../PopoverBase';

import type { PopoverProps } from './types';

const StyledPopover = styled(MuiPopover, {
  shouldForwardProp: prop => prop !== 'ownerZIndex',
})<{ ownerZIndex?: number }>`
  ${({ ownerZIndex }) => (ownerZIndex == null ? '' : `z-index: ${ownerZIndex};`)}
`;

const Popover = (props: PopoverProps) => {
  const {
    children,
    placement = 'top',
    anchorOrigin,
    transformOrigin,
    zIndex: zIndexProp,
    ...others
  } = props;
  const theme = useTheme();
  const popupContext = usePopupContext();

  const zIndex = zIndexProp ?? popupContext?.zIndex ?? theme.zIndex.contentPopup;

  const popoverOrigin: Pick<PopoverProps, 'anchorOrigin' | 'transformOrigin' | 'placement'> =
    useMemo(() => {
      const { anchorOrigin: placementAnchorOrigin, transformOrigin: placementTransformOrigin } =
        PopoverOrigin[placement];

      if (anchorOrigin && transformOrigin) {
        return {
          anchorOrigin,
          transformOrigin,
          placement: undefined,
        };
      }

      return {
        anchorOrigin: placementAnchorOrigin,
        transformOrigin: placementTransformOrigin,
        placement,
      };
    }, [anchorOrigin, placement, transformOrigin]);

  return (
    <StyledPopover ownerZIndex={zIndex} {...popoverOrigin} {...others}>
      {children}
    </StyledPopover>
  );
};

export default Popover;
